import React from 'react';
import { Link } from 'react-router-dom';
import Chart from 'react-apexcharts';
import Feature from '../Feature';
import VoiceChart from './charts/voiceChart';
import SmsChart from './charts/smsChart';
import { useState, useEffect } from 'react';
import { getOne, getList } from './../../common/v4/BackendProvider';
import { ToastContainer, toast } from 'react-toastify';

class Tile extends React.Component {
    render() {
        return (
            <div className={this.props.colorClass}>
                <div className="icon">
                    <i className={this.props.iconClass}></i>
                </div>
                <div className="num">{this.props.bigNumber}</div>
                <h3>{this.props.title}</h3>
                <p>{this.props.text}</p>
            </div>
        )
    }
}

class TileSmall extends React.Component {
    render() {
        return(
            <div className={this.props.colorClass}>
                <div className="icon">
                    <i className={this.props.iconClass}></i>
                </div>
                <div className="num-small">{this.props.title}</div>
                <p>{this.props.text}</p>
            </div>
        )
    }
}

class TileBlock extends React.Component {
    constructor (props) {
        super(props)
        this.state = {
            data: []
        }
    }
    componentWillReceiveProps(nextProps) {
        this.setState({
            data: nextProps.data
        })
    }
    render() {
        var asr = this.state.data.asr_today + "%";
        return (
            <div>
                <div className="row">
                    <Feature name="voice-wholesale">
                    <div className="col-sm-6 col-xs-12">
                        <div className="panel panel-default">
                            <div className="panel-heading">
                                <div className="panel-title">Voice Data</div>
                                <div className="panel-options"></div>
                            </div>
                            <div className="panel-body">
                                <div className="col-sm-6 col-xs-12">
                                    <TileSmall colorClass="tile-blue tile-stats" iconClass="icon-phone" title={this.state.data.minutes_today} text="Minutes Last 24h" />
                                </div>
                                <div className="col-sm-6 col-xs-12">
                                    <TileSmall colorClass="tile-blue tile-stats" iconClass="icon-thumbs-up" title="0" text="Calls Last 24h" />
                                </div>
                            </div>
                        </div>
                    </div>
                    </Feature>
                    <Feature name="voice-wholesale">
                    <div className="col-sm-6 col-xs-12">
                        <div className="panel panel-default">
                            <div className="panel-heading">
                                <div className="panel-title">Voice Data</div>
                                <div className="panel-options"></div>
                            </div>
                            <div className="panel-body">
                                <div className="col-sm-6 col-xs-12">
                                    <TileSmall colorClass="tile-blue tile-stats" iconClass="icon-phone" title="0:00" text="ACD Last 24h" />
                                </div>
                                <div className="col-sm-6 col-xs-12">
                                    <TileSmall colorClass="tile-blue tile-stats" iconClass="icon-thumbs-up" title={asr} text="ASR Last 24h" />
                                </div>
                            </div>
                        </div>
                    </div>
                    </Feature>
                    <Feature name="sms-wholesale">
                    <div className="col-sm-6 col-xs-12">
                        <div className="panel panel-default">
                            <div className="panel-heading">
                                <div className="panel-title">SMS Data</div>
                                <div className="panel-options"></div>
                            </div>
                            <div className="panel-body">
                                <div className="col-sm-6 col-xs-12">
                                    <TileSmall colorClass="tile-aqua tile-stats" iconClass="icon-chat" title={this.state.data.mt_messages_today} text="MT Messages Last 24h" />
                                </div>
                                <div className="col-sm-6 col-xs-12">
                                    <TileSmall colorClass="tile-aqua tile-stats" iconClass="icon-chat" title={this.state.data.mo_messages_today} text="MO Messages Last 24h" />
                                </div>
                            </div>
                        </div>
                    </div>
                    </Feature>
                    <Feature name="sms-wholesale">
                    <div className="col-sm-6 col-xs-12">
                        <div className="panel panel-default">
                            <div className="panel-heading">
                                <div className="panel-title">SMS Data</div>
                                <div className="panel-options"></div>
                            </div>
                            <div className="panel-body">
                                <div className="col-sm-6 col-xs-12">
                                    <TileSmall colorClass="tile-aqua tile-stats" iconClass="icon-chat" title={this.state.data.dlr_success_today} text="Success DLRs Last 24h" />
                                </div>
                                <div className="col-sm-6 col-xs-12">
                                    <TileSmall colorClass="tile-aqua tile-stats" iconClass="icon-chat" title={this.state.data.dlr_failed_today} text="Failed DLRs Last 24h" />
                                </div>
                            </div>
                        </div>
                    </div>
                    </Feature>
                </div>

                <div className="row">
                    <div className="col-sm-6 col-xs-12">
                        <div className="panel panel-default">
                            <div className="panel-heading">
                                <div className="panel-title">Payments</div>
                                <div className="panel-options"></div>
                            </div>
                            <div className="panel-body">
                                <div className="col-sm-6 col-xs-12">
                                    <TileSmall colorClass="tile-red tile-stats" iconClass="icon-credit-card" title={this.state.data.revenue_today} text="Received Last 24h" />
                                </div>
                                <div className="col-sm-6 col-xs-12">
                                    <TileSmall colorClass="tile-red tile-stats" iconClass="icon-credit-card" title={this.state.data.profit_today} text="Profit Last 24h" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-6 col-xs-12">
                        <div className="panel panel-default">
                            <div className="panel-heading">
                                <div className="panel-title">Invoices</div>
                                <div className="panel-options"></div>
                            </div>
                            <div className="panel-body">
                                <div className="col-sm-6 col-xs-12">
                                    <TileSmall colorClass="tile-red tile-stats" iconClass="icon-credit-card" title={this.state.data.invoices_new} text="Issued Last 24h" />
                                </div>
                                <div className="col-sm-6 col-xs-12">
                                    <TileSmall colorClass="tile-red tile-stats" iconClass="icon-credit-card" title={this.state.data.invoices_open} text="Total Open" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

class OnlineData extends React.Component {
    render() {
        if (this.props.numbers == undefined)
            return null;
        return(
            <div>
                <div className="panel panel-default">
                    <div className="panel-heading">
                        <div className="panel-title">Live Data</div>
                        <div className="panel-options"></div>
                    </div>
                    <div className="panel-body">
                        <Feature name="voice-wholesale">
                        <div className="row">
                            <h5>Active Calls</h5>
                        </div>
                        <div className="row">
                            <div className="col-12">
                                <TileSmall colorClass = "tile-white-blue tile-stats" iconClass="icon-phone" title={this.props.numbers.active_calls} text="Calls Active" />
                            </div>
                        </div>
                        </Feature>
                        <Feature name="sms-wholesale">
                        <div className="row">
                            <h5>SMS Messages</h5>
                        </div>
                        <div className="row">
                            <div className="col-12">
                                <TileSmall colorClass = "tile-white-aqua tile-stats" iconClass="icon-chat" title={this.props.numbers.mt_minute} text="MT per minute" />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12">
                                <TileSmall colorClass = "tile-white-aqua tile-stats" iconClass="icon-chat" title={this.props.numbers.mo_minute} text="MO per minute" />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12">
                                <TileSmall colorClass = "tile-white-aqua tile-stats" iconClass="icon-check" title={this.props.numbers.dlr_minute} text="DLR per minute" />
                            </div>
                        </div>
                        </Feature>
                    </div>
                </div>
            </div>
        )
    }
}


class ServerData extends React.Component {
    render() {
        if (this.props.servers == undefined)
            return null;
        return(
            <div>
                <div className="panel panel-default">
                    <div className="panel-heading">
                        <div className="panel-title">Server Status</div>
                        <div className="panel-options"></div>
                    </div>
                    <div className="panel-body">
                    {
                        this.props.servers.sip &&
                        <SipServers servers={this.props.servers.sip}/>
                    }
                    <Feature name="sms-wholesale">
                    {
                        this.props.servers.sms && Array.isArray(this.props.servers.sms) && this.props.servers.sms.length > 0 ?
                        <SmsServers servers={this.props.servers.sms}/> :
                        <div className="row">
                            <div className="col-12">
                                <p>No SMS servers found or loading...</p>
                            </div>
                        </div>
                    }
                    </Feature>
                    </div>
                </div>
            </div>
        )
    }
}

class SipServers extends React.Component {
    render() {
        return(
            <div>
                <div className="row">
                    <h5>Voice Servers</h5>
                </div>
                <div className="row">
                    {this.props.servers.map(function(row, index) {
                        if (row.ATRSTATUS == 0) {
                            var color = "tile-gray tile-stats"
                            var title = "DISABLED"
                        }  else {
                            var color = "tile-green tile-stats"
                            var title = "ONLINE"
                        }
                        return (
                            <div key= {index} className="col-12">
                                <TileSmall colorClass = {color} iconClass="icon-shuffle" title={title} text={row.ATRSRCIPADDR} />
                            </div>
                        )
                    }, this)}
                </div>
            </div>
        )
    }
}

class SmsServers extends React.Component {
    render() {
        // Ensure servers is an array
        const servers = Array.isArray(this.props.servers) ? this.props.servers : [];
        
        return(
            <div>
                <div className="row">
                    <h5>SMS Servers</h5>
                </div>
                <div className="row">
                    {servers.map(function(row, index) {
                        // Use the new API response structure
                        if (row.status == 0) {
                            var color = "tile-gray tile-stats"
                            var title = "DISABLED"
                        } else if (!row.is_online) {
                            var color = "tile-red tile-stats"
                            var title = "OFFLINE"
                        } else if (row.status == 1) {
                            var color = "tile-green tile-stats"
                            var title = "ONLINE"
                        }
                        return (
                            <div key= {index} className="col-12">
                                <Link to={`/home/smpp/${row.id}`}>
                                    <TileSmall colorClass = {color} iconClass="icon-shuffle" title={title} text={row.name} />
                                </Link>
                            </div>
                        )
                    }, this)}
                </div>
            </div>
        )
    }
}

class SmsGraph extends React.Component {
    constructor (props) {
        super(props)
        this.state = {         
            series: [{
                name: 'MT',
                data: []
            },
            {
                name: 'MO',
                data: [
                ]
            }],
            options: {
              chart: {
                id: 'area-datetime',
                type: 'area',
                height: 350,
                zoom: {
                  autoScaleYaxis: true
                }
              },
              annotations: {
                yaxis: [{
                  y: 30,
                  borderColor: '#999',
                  label: {
                    show: true,
                    text: 'Date/hour',
                    style: {
                      color: "#fff",
                      background: '#00E396'
                    }
                  }
                }],
                xaxis: [{
                  x: new Date('14 Nov 2012').getTime(),
                  borderColor: '#999',
                  yAxisIndex: 0,
                  label: {
                    show: true,
                    text: 'Count',
                    style: {
                      color: "#fff",
                      background: '#775DD0'
                    }
                  }
                }]
              },
              dataLabels: {
                enabled: false
              },
              markers: {
                size: 0,
                style: 'hollow',
              },
              xaxis: {
                type: 'datetime',
                tickAmount: 6,
              },
              tooltip: {
                x: {
                  format: 'yyyy-MM-dd HH'
                }
              },
              fill: {
                type: 'gradient',
                gradient: {
                  shadeIntensity: 1,
                  opacityFrom: 0.7,
                  opacityTo: 0.9,
                  stops: [0, 100]
                }
              },
            },
            selection: 'one_year',
          };
        }
    componentDidUpdate(prevProps) {
        if (this.props.series !== prevProps.series) {
            const series = [{
                name: 'MT',
                data: this.props.series.MT
            },
            {
                name: 'MO',
                data: this.props.series.MO
            }] 
            this.setState({series: series});
        }
    }
    render() {
       return (
           <div className="dashchart">
               <Chart options={this.state.options} series={this.state.series} type="area" height={350} />
           </div>
        )
    }
}

class VoiceGraph extends React.Component {
    render() {
        return (
            <div className="dashchart">
                <div id="callschart"></div>
            </div>
        )
    }
}


const Dashboard = () => {

    const [graphs, setGraphs] = useState({
        voice: [],
        sms: []
    });

    const [numbers, setNumbers] = useState({});
    const [live, setLive] = useState({});
    const [servers, setServers] = useState({sms: []});
    const [data, setData] = useState({});
    const [smsServers, setSmsServers] = useState([]);
    
    
    useEffect(() => {
        getOne(`/admin/dashboard/`, 'main')
            .then(response => {
                setData(response.data.data || {});
                if (response.data.live) {
                    setLive(response.data.live);
                }
            }).catch(error => {
                toast.error("Error fetching dashboard data: " + error.message, {});
            });
    }, []);

    // Fetch SMS live data every minute
    useEffect(() => {
        const fetchSmsLiveData = () => {
            getList('/admin/dashboard/sms-live')
                .then(response => {
                    setLive(prevLive => ({
                        ...prevLive,
                        ...response.data
                    }));
                }).catch(error => {
                    console.error("Error fetching SMS live data:", error);
                });
        };

        // Fetch immediately
        fetchSmsLiveData();

        // Set up interval to fetch every minute (60000ms)
        const interval = setInterval(fetchSmsLiveData, 60000);

        // Cleanup interval on component unmount
        return () => clearInterval(interval);
    }, []);

    // Fetch SMS server status every 30 seconds
    useEffect(() => {
        const fetchSmsServerStatus = () => {
            getList('/admin/dashboard/sms-servers-status')
                .then(response => {
                    setSmsServers(response.data.data || []);
                }).catch(error => {
                    console.error("Error fetching SMS server status:", error);
                });
        };

        // Fetch immediately
        fetchSmsServerStatus();

        // Set up interval to fetch every 30 seconds (30000ms)
        const interval = setInterval(fetchSmsServerStatus, 30000);

        // Cleanup interval on component unmount
        return () => clearInterval(interval);
    }, []);

    return (
        <div>
            <div className="row">
                    <div className="col-md-12">
                        <h2>Dashboard</h2>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-8">
                        
                        <div className="row">
                            <Feature name="voice-wholesale">
                            <div className="col-md-12">
                                <div className="panel panel-default">
                                    <div className="panel-heading">
                                        <div className="panel-title">Voice</div>
                                        <div className="panel-options"></div>
                                    </div>
                                    <div className="panel-body">
                                        <VoiceChart data = {graphs.voice} />
                                    </div>
                                </div>
                            </div>
                        </Feature>
                        <Feature name="sms-wholesale">
                            <div className="col-md-12">
                                <div className="panel panel-default">
                                    <div className="panel-heading">
                                        <div className="panel-title">Data</div>
                                        <div className="panel-options"></div>
                                    </div>
                                    <div className="panel-body">
                                        <SmsChart key="sms-chart" />
                                    </div>
                                </div>
                            </div>
                        </Feature>
                        </div>
                        <div className="row">
                            <div className="col-md-12">
                                <TileBlock data= {data} />
                            </div>
                        </div>
                    </div>
                    <div className="col-md-2">
                        <div className="row">
                            <div className="col-md-12 dash-online">
                                <OnlineData  numbers={live} />
                            </div>
                        </div>
                    </div>
                    <div className="col-md-2">
                        <div className="row">
                            <div className="col-md-12 dash-servers">
                                <ServerData servers={{...servers, sms: smsServers}} />
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        )
}

export default Dashboard;
